import { Checkbox, Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyLegal({ handleChange, formData, userUUID, isForUser }: any) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <CreateDropZone
            isRequired
            title={'Commercial Register Excerpt'}
            description="Upload current Handelsregister/Firmenbuch extract."
            onFilesChange={(files) => handleChange?.('commercialRegister', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.commercialRegister ?? []}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            isRequired
            title={'Trade/Business Registration Certificate'}
            description="Gewerbeanmeldung or equivalent licence to trade."
            onFilesChange={(files) => handleChange?.('tradeCertificate', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.tradeCertificate ?? []}
          />
        </div>
      </div>
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            isRequired
            label="Authorized Signatories & Powers"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Names plus POA or notarised authorisations."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.authorizedSignatories}
            onChange={(e) => handleChange?.('authorizedSignatories', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            isRequired
            title={'Documentary evidence'}
            description="Names plus POA or notarised authorisations."
            onFilesChange={(files) => handleChange?.('authorizedSignatoriesFiles', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.authorizedSignatoriesFiles ?? []}
          />
        </div>
      </div>
      <CreateDropZone
        isRequired
        title={'Tax & Social Security Compliance Certificates'}
        description="Certificates proving no tax or social-insurance arrears."
        onFilesChange={(files) => handleChange?.('taxComplianceCertificate', files)}
        userUUID={userUUID}
        isForUser={isForUser}
        files={formData?.taxComplianceCertificate ?? []}
      />
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            isRequired
            label="Criminal Record Declaration"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Statement and Führungszeugnis for executives."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.criminalRecordDescription}
            onChange={(e) => handleChange?.('criminalRecordDescription', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            isRequired
            title={'Attachments'}
            description="."
            onFilesChange={(files) => handleChange?.('criminalRecordAttachments', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.criminalRecordAttachments ?? []}
          />
        </div>
      </div>
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Compliance Certifications"
            labelPlacement="outside"
            variant="bordered"
            placeholder="List/upload ISO 9001, 27001, 14001, etc."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.complianceCertificateText}
            onChange={(e) => handleChange?.('complianceCertificateText', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Certificates'}
            description="."
            onFilesChange={(files) => handleChange?.('complianceCertificateFiles', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.complianceCertificateFiles ?? []}
          />
        </div>
      </div>
      <Textarea
        isRequired
        label="GDPR & Data Protection Measures"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Outline DPO, policies, TOMs."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.gdprMeasures}
        onChange={(e) => handleChange?.('gdprMeasures', e.target.value)}
      />
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Anti-Corruption & Ethics Policy"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Describe/upload anti-bribery code."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            value={formData?.antiCorruptionText}
            onChange={(e) => handleChange?.('antiCorruptionText', e.target.value)}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Attachments'}
            description="."
            onFilesChange={(files) => handleChange?.('antiCorruptionFiles', files)}
            userUUID={userUUID}
            isForUser={isForUser}
            files={formData?.antiCorruptionFiles ?? []}
          />
        </div>
      </div>

      <Checkbox
        defaultSelected
        radius="full"
        onChange={(e) => handleChange?.('sanctionCompliance', e.target.checked)}
        value={formData?.sanctionCompliance}
      >
        Sanctions Compliance Confirmation
      </Checkbox>
      <Checkbox
        defaultSelected
        radius="full"
        onChange={(e) => handleChange?.('regulatoryExclusion', e.target.checked)}
        value={formData?.regulatoryExclusion}
      >
        Regulatory Exclusion Grounds Declaration
      </Checkbox>
    </div>
  )
}
